export enum Clients {
  CMG = 'cmg',
}

export enum ClientTimezones {
  CMG = 'America/Los_Angeles',
}
